module.exports = __webpack_public_path__ + "img/CobravsNZA.d36fafef.png";